if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('product-info');

            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient')
            this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}


// CODE I ADDED MYSELF------------------------------------------------------------------------
// Move all popups to body on page load for correct positioning
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.quick-add-popup').forEach(function(popup) {
    document.body.appendChild(popup);
  });

  // Variant image swap
  document.querySelectorAll('.quick-add-popup__select').forEach(function(select) {
    select.addEventListener('change', function() {
      var productId = this.dataset.productId;
      var variantId = this.value;
      var imgEl = document.querySelector('#popup-' + productId + ' .quick-add-popup__image');
      if (!imgEl) return;

      fetch('/variants/' + variantId + '.js')
        .then(function(r) { return r.json(); })
        .then(function(variant) {
          if (variant.featured_image && variant.featured_image.src) {
            imgEl.src = variant.featured_image.src + '&width=300';
            imgEl.alt = variant.featured_image.alt || '';
          }
        })
        .catch(function(err) { console.log('Variant image error:', err); });
    });
  });
});

function openQuickAddPopup(productId) {
  var popup = document.getElementById('popup-' + productId);
  popup.style.display = 'flex';
  popup.classList.add('is-open');
  document.body.style.overflow = 'hidden';
  document.body.classList.add('popup-open');
}

function closeQuickAddPopup(productId) {
  var popup = document.getElementById('popup-' + productId);
  popup.style.display = 'none';
  popup.classList.remove('is-open');
  document.body.style.overflow = '';
  document.getElementById('feedback-' + productId).textContent = '';
  document.body.classList.remove('popup-open');
}

function addToCartFromPopup(productId) {
  var variantEl = document.getElementById('variant-' + productId);
  var quantityEl = document.getElementById('quantity-' + productId);
  var feedback = document.getElementById('feedback-' + productId);
  var variantId = variantEl.value;
  var quantity = parseInt(quantityEl.value) || 1;

  console.log('Adding variant:', variantId, 'qty:', quantity);

  if (!variantId) {
    feedback.style.color = 'red';
    feedback.textContent = 'Please select an option.';
    return;
  }

  feedback.style.color = '#333';
  feedback.textContent = 'Adding...';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: parseInt(variantId), quantity: quantity })
  })
  .then(function(res) {
    if (!res.ok) {
      return res.json().then(function(err) { throw err; });
    }
    return res.json();
  })
  .then(function(data) {
    feedback.style.color = 'green';
    feedback.textContent = '✓ Added to cart!';
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var countEls = document.querySelectorAll('[data-cart-count], .cart-count, #cart-count');
        countEls.forEach(function(el) { el.textContent = cart.item_count; });
      });
    setTimeout(function() { closeQuickAddPopup(productId); }, 1000);
  })
  .catch(function(err) {
    console.error('Cart error:', err);
    feedback.style.color = 'red';
    feedback.textContent = err.description || 'Could not add to cart. Please try again.';
  });
}


